import { render, staticRenderFns } from "./CartSwapPopUp.vue?vue&type=template&id=56195a1c&scoped=true"
import script from "./CartSwapPopUp.vue?vue&type=script&lang=js"
export * from "./CartSwapPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56195a1c",
  null
  
)

export default component.exports